import { types } from "../types";

export interface IGameInformationStateProps {
  gameProducer?: string;
  gameName?: string;
  gameClientVersion?: string;
  gameServerVersion?: string;
  maxBet?: number;
  minBet?: number;
}

export const defaultState: IGameInformationStateProps = {
  gameName: "Game Name",
  gameProducer: "Game Producer",
  gameClientVersion: null,
  gameServerVersion: null,
  maxBet: null,
  minBet: null
};

export const gameInformation = (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_STATE:
      const { gameInformation = {} } = action.value;
      return {
        ...state,
        ...gameInformation
      };
    default:
      return state;
  }
};
